import script from "./ClientDocumentHeaderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDocumentHeaderCard.vue?vue&type=script&setup=true&lang=js"

import "./ClientDocumentHeaderCard.vue?vue&type=style&index=0&id=64b57f9c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b57f9c"]])

export default __exports__